<template>
  <div>
    <b-table-simple class="export-table m-0" borderless outlined style="border-bottom: 0 !important;">
      <b-thead>
        <b-tr class="title-row">
          <b-th colspan="2">{{ lodash.startCase($t('purchase_orders.singular')) }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td style="padding: 8px 16px 4px 16px; width: 125px">{{ lodash.startCase($t('sale_notes.resumes.date')) }}</b-td>
          <b-td style="padding: 8px 16px 4px 16px">: <span style="color: #6C7589">{{ dateFormatter(orderedAt) }}</span></b-td>
        </b-tr>
        <b-tr>
          <b-td style="padding: 4px 16px">{{ lodash.startCase($t('sale_notes.resumes.partner')) }}</b-td>
          <b-td style="padding: 4px 16px">: <span style="color: #6C7589">{{ partnerName }}</span></b-td>
        </b-tr>
        <b-tr>
          <b-td style="padding: 4px 16px 8px 16px">{{ lodash.startCase($t('products.singular')) }}</b-td>
          <b-td style="padding: 4px 16px 8px 16px">: <span style="color: #6C7589">{{ lodash.startCase(serviceName) }}</span></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-table-simple class="export-table" borderless outlined style="border-top: 0 !important;">
      <b-thead>
        <b-tr>
          <b-th rowspan="2" style="width: 1%">No</b-th>
          <b-th rowspan="2" style="width: 180px">{{ lodash.startCase($t('sale_notes.resumes.product_name')) }}</b-th>
          <b-th rowspan="2">{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('units.kg')})` }}</b-th>
          <b-th rowspan="2">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
          <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.harvest_price')) }}</b-th>
          <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.sell_price')) }}</b-th>
        </b-tr>
        <b-tr>
          <b-th style="text-align: center">{{ `/${$t('units.kg')}` }}</b-th>
          <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.total')) }}</b-th>
          <b-th style="text-align: center">{{ `/${$t('units.kg')}` }}</b-th>
          <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.total')) }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="({
        name,
        quantity,
        size,
        purchase_price,
        total_purchase_price,
        sell_price,
        total_sell_price,
        }, index) in tableItems" v-bind:key="index">
          <b-td>{{ index + 1 }}</b-td>
          <b-td>{{ name }}</b-td>
          <b-td>{{ decimalFormatter(quantity) }}</b-td>
          <b-td>{{ size }}</b-td>
          <b-td style="text-align: center">{{ currencyFormatter(purchase_price) }}</b-td>
          <b-td style="text-align: center">{{ currencyFormatter(total_purchase_price) }}</b-td>
          <b-td style="text-align: center">{{ currencyFormatter(sell_price) }}</b-td>
          <b-td style="text-align: center">{{ currencyFormatter(total_sell_price) }}</b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th></b-th>
          <b-th></b-th>
          <b-th :class="{'text-success': totalBiomass > 0, 'text-danger': totalBiomass < 0}">{{ lodash.startCase(`${decimalFormatter(totalBiomass)} ${$t('units.kg')}`) }}</b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th :class="{'text-success': totalPurchasePrice > 0, 'text-danger': totalPurchasePrice < 0}" style="text-align: center">{{ currencyFormatter(totalPurchasePrice)}}</b-th>
          <b-th></b-th>
          <b-th :class="{'text-success': totalSellPrice > 0, 'text-danger': totalSellPrice < 0}" style="text-align: center">{{ currencyFormatter(totalSellPrice) }}</b-th>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'purchase-order-export',
  props: {
    value: {type: Object, default() { return {} }},
  },
  computed:{
    orderedAt() {
      let {
        trip: {
          purchase_order: {
            ordered_at
          } = {}
        }
      } = this.value
      if (!ordered_at) return null
      return ordered_at
    },
    partnerName() {
      let {
        trip: {
          purchase_order: {
            customer: {
              name
            } = {}
          } = {}
        },
      } = this.value

      if (!name) return '-'
      return name
    },
    serviceName() {
      let {
        trip: {
          purchase_order: {
            product: {
              name
            } = {}
          } = {}
        },
      } = this.value

      if (!name) return '-'
      return name
    },
    tableItems() {
      return this.value?.sale_items?.map(({
        trip_items,
        quality,
        unit_price: sell_unit_price,
        total_price: total_sell_price,
      }) => {
        let {
          quantity,
          size,
          unit_price: purchase_price,
          total_price: total_purchase_price
        } = trip_items[0] ?? {}

        return {
          name: `Vannamei/${this.qualityFormatter(quality)}/Size ${size}`,
          quantity: quantity,
          size: size,
          purchase_price: purchase_price,
          total_purchase_price: total_purchase_price,
          sell_price: sell_unit_price,
          total_sell_price: total_sell_price,
        }
      })
    },
    totalBiomass () {
      return this.value?.sale_item_total_initial_quantity ?? 0
    },
    totalPurchasePrice() {
      return this.tableItems.reduce((carry, {total_purchase_price}) => carry + total_purchase_price, 0)
    },
    totalSellPrice() {
      return this.value?.sale_item_total ?? 0
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    dateFormatter(date) {
      if (!date) return '-'
      return this.$moment.utc(date).local().format('DD MMMM YYYY')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style scoped>

</style>